import { render } from "./RegisterCustomer.vue?vue&type=template&id=652fd3ac"
import script from "./RegisterCustomer.vue?vue&type=script&lang=js"
export * from "./RegisterCustomer.vue?vue&type=script&lang=js"

import "./RegisterCustomer.vue?vue&type=style&index=0&id=652fd3ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__